var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.shouldNotify)?_c('div',{class:[(_vm.$appPrefix + "-cms-slider-item-aufbauplus")]},[_c('TextBildModule',{attrs:{"instance":_vm.instance}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }